import React from "react";
import PropTypes from "prop-types";
import styles from "./WarningPrimaryModal.module.css";

import { Button } from "../Button/Button";
import Modal from "components/Modal";
import { useTranslation } from "react-i18next";

/**
 * Interactive component
 *
 * Modal used to warn there should be a primary address
 */

export function WarningPrimaryModal({ isOpen, title, description, onClick }) {
  const {t} = useTranslation();
  return (
    <>
      <Modal
        isOpen={isOpen}
        classNames={styles.modal}
        title={""}
        children={
          <>
            <div className={styles.container}>
              <div className={styles.content}>
                <p className={styles.title}>{title}</p>
                <p className={styles.text}>{description}</p>
              </div>
              <div className={styles.cancel}>
                <Button buttonText={t("Okay")} onClick={onClick} />
              </div>
            </div>
          </>
        }
      />
      {/* </div>
      )} */}
    </>
  );
}

WarningPrimaryModal.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
};

export default WarningPrimaryModal;
